<script setup lang="ts">
useSeoMeta({
  title: 'Apostas Esportivas | Casa de Apostas Online',
  ogTitle: 'Apostas Esportivas | Casa de Apostas Online',
  description:
    'Apostas esportivas online com diversas opções de esportes e promoções. Plataforma segura com estatísticas dos jogos e suporte ao cliente 24/7. 18+ | Jogue com responsabilidade.',
  ogDescription:
    'Apostas esportivas online com diversas opções de esportes e promoções. Plataforma segura com estatísticas dos jogos e suporte ao cliente 24/7. 18+ | Jogue com responsabilidade.',
});

const {
  isAltenarTestModeEnabled,
  isAltenarEnabled,
  isBetByTestModeEnabled,
  isBetByEnabled,
  isCactusSportsbookEnabled,
  isCactusSportsbookTestModeEnabled,
} = useFeatureFlagsEnv();

const { hasSportBookActive, sportBookSlugFromUrl, goToSportsHomePage } =
  useSportsBook();

const user = ref({});
const isLoadingVisible = ref<boolean>(true);
const { isAuthenticated } = storeToRefs(useAuthStore());
const { userId } = useUserData();
const { headerHeight, topBarHeight, horizontalMenuHeight, bottomMenuHeight } =
  useLayout();

const isBetbyPageTest = computed<boolean>(() => {
  // @ts-ignore
  return sportBookSlugFromUrl.value === 'betby';
});

const isBetbyHomologationPage = computed<boolean>(() => {
  return isBetbyPageTest.value && isBetByTestModeEnabled.value;
});

const isAltenarPageTest = computed<boolean>(() => {
  // @ts-ignore
  return sportBookSlugFromUrl.value === 'altenar';
});

const isAltenarHomologationPage = computed<boolean>(() => {
  return isAltenarPageTest.value && isAltenarTestModeEnabled.value;
});

const isCactusPageTest = computed<boolean>(() => {
  // @ts-ignore
  return sportBookSlugFromUrl.value === 'ft';
});

const isCactusHomologationPage = computed<boolean>(() => {
  return isCactusPageTest.value && isCactusSportsbookTestModeEnabled.value;
});

const isCactusSportbookReallyEnabled = computed<boolean>(() => {
  if (isBetbyHomologationPage.value || isAltenarHomologationPage.value) {
    return false;
  }

  return isCactusSportsbookEnabled.value || isCactusHomologationPage.value;
});

const isBetByReallyEnabled = computed<boolean>(() => {
  if (isCactusHomologationPage.value || isAltenarHomologationPage.value) {
    return false;
  }

  return isBetByEnabled.value || isBetbyHomologationPage.value;
});

const isAltenarReallyEnabled = computed<boolean>(() => {
  if (isCactusHomologationPage.value || isBetbyHomologationPage.value) {
    return false;
  }

  return isAltenarEnabled.value || isAltenarHomologationPage.value;
});

const isMaintenanceAlertVisible = computed<boolean>(() => {
  if (isBetbyHomologationPage.value || isCactusHomologationPage.value) {
    return false;
  }

  return !hasSportBookActive.value;
});

const sportsPageHeight = computed<string>(() => {
  const sumHeight =
    headerHeight.value +
    topBarHeight.value +
    horizontalMenuHeight.value +
    bottomMenuHeight.value;

  return `calc(100dvh - ${sumHeight}px)`;
});

function onLoadingStateChange(isLoading: boolean) {
  isLoadingVisible.value = isLoading;
}

onBeforeMount(() => {
  const isUnallowedTestPage =
    (isBetbyPageTest.value && !isBetByTestModeEnabled.value) ||
    (isCactusPageTest.value && !isCactusSportsbookTestModeEnabled.value);

  if (isUnallowedTestPage) {
    return goToSportsHomePage();
  }
});

const getUser = computed(() => {
  if (isAuthenticated.value) {
    return (user.value = {
      user_id: userId.value,
    });
  } else {
    return (user.value = { user_id: null });
  }
});

const { goToLocaleRoute } = useRoutes();

onMounted(() => {
  // Temporary fix
  setTimeout(() => {
    isLoadingVisible.value = false;
  }, 1000);
});

onBeforeMount(async () => {
  const { fetchUserProfile } = useUserData();

  await fetchUserProfile();
});
</script>

<template>
  <div :class="$style.sportsPage">
    <div
      v-if="isLoadingVisible && hasSportBookActive"
      :class="$style.loading"
    >
      <BaseCommonLogo
        always-icon
        :class="[$style.pulse, 'max-h-6 md:max-h-7']"
        custom-size
      />
    </div>

    <ClientOnly>
      <template v-if="isCactusSportbookReallyEnabled">
        <SportsCactusSportbook />
      </template>

      <template v-else-if="isAltenarReallyEnabled">
        <SportsAltenar />
      </template>

      <template v-else-if="isBetByReallyEnabled">
        <SportsBetby
          :user="getUser"
          @change-loading-state="onLoadingStateChange"
        />
      </template>

      <template v-else-if="isMaintenanceAlertVisible">
        <BaseErrorMessage
          image-type="maintenance"
          :message="$t('error.sports.message')"
          :subtitle="$t('error.sports.subtitle')"
          :title="$t('error.sports.title')"
        >
          <button @click="goToLocaleRoute({ name: 'index' })">
            {{ $t('error.sports.button') }}
          </button>
        </BaseErrorMessage>
      </template>
    </ClientOnly>
  </div>
</template>

<style module lang="postcss">
.sportsPage {
  @apply min-w-full;
  @apply flex justify-center relative;

  min-height: v-bind(sportsPageHeight);
}

.loading {
  @apply h-full absolute flex items-center z-10;
}

.pulse {
  animation: pulse 1s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.1);
    opacity: 0.5;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
